import DocumentHead from '@/components/document-head/DocumentHead'
import LoadingPanel from '@/components/loading-panel/LoadingPanel'
import ReceiptOCR, { IReceiptOCRRef } from '@/components/receipt-ocr/ReceiptOCR'
import ExpenseEditorForm from '@/routes/expenses/ExpenseEditor.form'
import { expenseEditorRouteLoader } from '@/routes/expenses/ExpenseEditor.route'
import { ExpenseEditorProps } from '@/routes/expenses/ExpenseEditor.types'
import { isUserRoleAllowed } from '@/routes/utils'
import { FormRef } from 'devextreme-react/cjs/form'
import notify from 'devextreme/ui/notify'
import { Suspense, useEffect, useRef } from 'react'
import { useFetcher, useSearchParams } from 'react-router-dom'
import { Await, useLoaderData } from 'react-router-typesafe'

const ExpenseEditor = (props: ExpenseEditorProps) => {
  const { creating } = props
  const { title, expense, userInfo, defaultCRUDAllowedRoles, getEmployees, getTypes } =
    useLoaderData<typeof expenseEditorRouteLoader>()
  const fetcher = useFetcher()
  const receiptOcrRef = useRef<IReceiptOCRRef>(null)
  const formRef = useRef<FormRef>(null)
  const [searchParams] = useSearchParams()
  const dateSP = searchParams.get('date')

  useEffect(() => {
    if (!creating) {
      receiptOcrRef.current?.clear()
      formRef.current?.instance().updateData('file', null)
    }
  }, [expense, creating])

  return (
    <>
      <h2>{title}</h2>
      <ReceiptOCR
        ref={receiptOcrRef}
        showImagePreview={true}
        onChanged={(data: Date | null, totale: number | null, file: File | null) => {
          if (creating) {
            if (dateSP === null) formRef.current?.instance().updateData('data', data)
            formRef.current?.instance().updateData('totale', totale)
          }
          formRef.current?.instance().updateData('file', file)

          formRef.current?.instance().getButton('btn-save')?.option('disabled', false)
          formRef.current?.instance().getButton('btn-cancel')?.option('disabled', false)
        }}
        expense={expense}
        creating={creating}
      ></ReceiptOCR>
      <Suspense fallback={<LoadingPanel />}>
        <Await resolve={Promise.all([getEmployees, getTypes])}>
          {([employees, types]) => (
            <>
              <div id="editor-expense-container" className={`dx-card responsive-paddings`}>
                <fetcher.Form>
                  <ExpenseEditorForm
                    creating={creating}
                    expense={expense}
                    impiegati={employees.data.value}
                    tipologie={types.data.value}
                    userInfo={userInfo}
                    isRoleAllowed={isUserRoleAllowed(userInfo?.roles, defaultCRUDAllowedRoles)}
                    fetcher={fetcher}
                    formRef={formRef}
                    onSaveClick={async () => {
                      const validationResult = formRef.current?.instance().validate()
                      if (!validationResult?.isValid) return
                      if (expense) {
                        if (!expense.file && creating) {
                          notify('Inserire uno scontrino', 'warning', 2000)
                          return
                        }
                        const formData = new FormData()
                        formData.append('expense', JSON.stringify(expense))
                        if (expense.file) {
                          formData.append('file', expense.file)
                        }
                        fetcher?.submit(formData, {
                          method: creating ? 'POST' : 'PUT',
                          encType: 'multipart/form-data',
                        })
                      } else console.log('no data tu submit')
                    }}
                  ></ExpenseEditorForm>
                </fetcher.Form>
              </div>
            </>
          )}
        </Await>
      </Suspense>
    </>
  )
}

export default ExpenseEditor
